var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _vm.plugin && _vm.isServiceOnline && _vm.pluginInterface
        ? _c(_vm.pluginInterface.component, { tag: "component" })
        : _vm._e(),
      _vm._v(" "),
      _vm.isInitialized === true && _vm.isServiceOnline === false
        ? _c(
            "div",
            [
              _c(
                "v-alert",
                { attrs: { outline: "", value: true, type: "error" } },
                [
                  _vm._v(
                    "Uh oh! This plugin is not available, please contact technical support\n      if the problem persists."
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isInitialized === false
        ? _c(
            "div",
            [
              _c(
                "v-alert",
                { attrs: { outline: "", value: true, type: "error" } },
                [
                  _vm._v(
                    "Uh oh! This plugin encountered an error, please contact technical\n      support if the problem persists."
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }